import React__default, { useState, useEffect } from 'react';
import Select, { components } from 'react-select';
import classnames from 'classnames';
import { ArrowDown } from '../../Icons/ArrowDown/index.js';
import '../../Icons/Camera/index.js';
import '../../Icons/Category/index.js';
import '../../Icons/CheckCircle/index.js';
import { Close } from '../../Icons/Close/index.js';
import '../../Icons/Favorite/index.js';
import '../../Icons/Lens/index.js';
import '../../Icons/LensHeart/index.js';
import '../../Icons/Phone/index.js';
import '../../Icons/Pin/index.js';
import '../../Icons/Promo/index.js';
import '../../Icons/Share/index.js';
import '../../Icons/Bell/index.js';
import '../../Icons/Bin/index.js';
import '../../Icons/Check/index.js';
import '../../Icons/TriangleExclamation/index.js';
import '../../Icons/ShoppingBag/index.js';
import { getMatchingOption, isPlainOption } from './helper.js';
export { isGroupOption } from './helper.js';
import styles from './index.module.scss.js';

// Style configuration for react-select components
const selectClassNames = {
    indicatorsContainer: () => styles.indicatorsContainer,
    option: (state) => classnames(styles.option, {
        [styles.focusedOption]: state.isFocused,
        [styles.selectedOption]: state.isSelected,
    }),
    dropdownIndicator: (state) => classnames(styles.dropdownIndicator, {
        [styles.dropdownIndicatorOpen]: state.selectProps.menuIsOpen,
    }),
    valueContainer: () => styles.valueContainer,
    container: () => styles.container,
    menu: () => styles.menu,
    menuList: () => styles.menuList,
    multiValue: () => styles.multiValue,
    noOptionsMessage: () => styles.noOptionsMessage,
    placeholder: () => styles.placeholder,
    control: () => styles.control,
    groupHeading: () => styles.groupHeading,
};
const customComponents = {
    DropdownIndicator: (props) => (React__default.createElement(components.DropdownIndicator, { ...props },
        React__default.createElement(ArrowDown, null))),
    ClearIndicator: (props) => (React__default.createElement(components.ClearIndicator, { ...props },
        React__default.createElement(Close, null))),
    IndicatorSeparator: () => null,
};
const Combobox = ({ noResultMessage = 'Nessun risultato trovato', size = 'md', ariaLabel, disabled, ...props }) => {
    // selectValue NEED to be null and not undefined for react-select to work
    // properly when the value need to be cleared
    const [selectValue, setSelectValue] = useState(null);
    const noOptionsMessage = () => noResultMessage;
    const handleSingleValueChange = (selectedOption) => {
        if (!props.multiple && (!selectedOption || isPlainOption(selectedOption))) {
            setSelectValue(selectedOption);
            props.onValueChange?.(selectedOption?.value);
        }
    };
    const handleMultipleValueChange = (selectedOptions) => {
        if (props.multiple && selectedOptions) {
            setSelectValue(selectedOptions);
            props.onValueChange?.(selectedOptions.filter(isPlainOption).map((option) => option.value));
        }
    };
    /**
     * Reflect the value prop in the selectValue state.
     * This is needed to make the component controlled
     * and to make it work properly when the value prop is changed from outside.
     */
    useEffect(() => {
        if (!props.value) {
            setSelectValue(null);
            return;
        }
        if (props.multiple) {
            setSelectValue(props.value
                .map((value) => getMatchingOption(value, props.options))
                .filter((value) => !!value));
        }
        else {
            setSelectValue(getMatchingOption(props.value, props.options));
        }
    }, [props.value, props.multiple, props.options]);
    return props.multiple ? (React__default.createElement(Select, { ...props, value: selectValue, onInputChange: props.onSearch, onChange: handleMultipleValueChange, noOptionsMessage: noOptionsMessage, classNames: selectClassNames, className: styles[size], components: customComponents, isDisabled: disabled, "aria-label": ariaLabel, isClearable: true, unstyled: true, isMulti: true })) : (React__default.createElement(Select, { ...props, value: selectValue, onInputChange: props.onSearch, onChange: handleSingleValueChange, noOptionsMessage: noOptionsMessage, classNames: selectClassNames, className: styles[size], components: customComponents, isDisabled: disabled, "aria-label": ariaLabel, isClearable: true, unstyled: true }));
};

export { Combobox, isPlainOption };
//# sourceMappingURL=index.js.map
